import { Component, OnInit, ViewChild, AfterViewInit, AfterContentInit, AfterViewChecked } from '@angular/core';
import { MeasurementDecision, Languages, ServiceStatus, FormMode } from 'src/app/shared/models/enums.model';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { TransitAdminDto } from '../../shared/models/transit-admin.model';
import { TransitRequestComponent } from 'src/app/front-user/services/e-booking/transit-request/transit-request.component';
import { User } from 'src/app/front-user/shared/models/user.model';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { TransitAdminService } from '../../shared/services/transit-admin.service';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { FeesEstimate } from 'src/app/front-user/services/e-booking/fees-estimation-request/fees-estimate.model';
import { TransitService } from 'src/app/front-user/services/e-booking/transit-request/transit-request.service';
import { first } from 'rxjs/operators';
import { TransitRequestDto } from 'src/app/front-user/services/e-booking/transit-request/transit-request.model';

@Component({
  selector: 'app-measurement-extra-fees',
  templateUrl: './measurement-extra-fees.component.html',
  styleUrls: ['./measurement-extra-fees.component.css']
})
export class MeasurementExtraFeesComponent implements OnInit, AfterViewInit {

  measurementDecisionForm: FormGroup;
  decision = MeasurementDecision;
  decisionKeys = Object.keys(this.decision);
  displayedLang: string;
  baseRequestId: string = '';
  decisionValue: number;
  submitted = false;
  loading = false;
  adminDecisionObject: TransitAdminDto = new TransitAdminDto();

  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  transitData: TransitRequestDto = new TransitRequestDto();
  numberRegex: string = '^[0-9]+(\\.?[0-9]+)?$';
  @ViewChild('transitRequest',{static: false}) transitRequest: TransitRequestComponent;
  error: any = { isError: false, errorMessage: '' };
  user: User = new User();
  baseRequestDTO: BaseRequest //= new BaseRequest();
  showRequest = false;
  requestStatus: number;
  FeesEstimateObj: FeesEstimate = new FeesEstimate();
  responseObj: ResponseObject = new ResponseObject();
  isErrorMessage: boolean = false;
  lockTaskErrorMessage: boolean = false;
  constructor(private formBuilder: FormBuilder,
    private globalSrv: GlobalServices, private alertService: AlertService,
    private route: ActivatedRoute, private router: Router,
    private authenticationService: AuthenticationService,
    private adminSrv: TransitAdminService, private translate: TranslateService,
    private baseRequestService: BaseRequestService, private transitSrv: TransitService) {

    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    // this.baseRequestId ='69B0AF21-E270-4C80-84C9-40ECA77F4261';
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getBaseRequest();
    }else{
      window.history.back();
    }
    this.user = this.globalSrv.user;

  }

  ngOnInit() {

    this.buildForm();

  }

  ngAfterViewInit(): void {

  }
  receiveFeesValue($event) {
    this.FeesEstimateObj = $event;
    if (this.baseRequestId && this.FeesEstimateObj) {
      this.measurementDecisionForm.patchValue({
        TotalFees: this.FeesEstimateObj.TotalFees,
      });
    }
  }

  getBaseRequest() {
    this.baseRequestService.getBaseRequest(this.baseRequestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;
        this.requestStatus = this.baseRequestDTO.StatusId;

        if (this.requestStatus == ServiceStatus.PendingOnMeasurementsOfficerApproval) {
          this.formMode = FormMode.Add;
          this.measurementDecisionForm.enable();
          this.measurementDecisionForm.controls.TotalFees.disable();

        }
        else if (history.state.data && history.state.data.isCompleted) {
          this.getTransitRequest();
        }
        else {
          this.getTransitRequest();
        }

        this.getMarineData();
      }
    )
  }

  buildForm() {
    this.measurementDecisionForm = this.formBuilder.group({
      Decision: ['', [Validators.required]],
      MeasureExtraFee: ['', [Validators.pattern(this.numberRegex), CustomValidators.textSpaceValidator()]],
      TotalFees: new FormControl({ value: this.FeesEstimateObj.TotalFees, disabled: true }),
      DocuemntName: [''],
      MeasurementDescription: [''],
      IsArrived: new FormControl({ value: true, disabled: true }),
      ETA: new FormControl({ value: '', disabled: true }),
      ETATime: new FormControl({ value: '', disabled: true }),
      Requirements: new FormControl({ value: '', disabled: true })
    });
  }



  public getMarineData() {
    this.transitSrv.get(this.baseRequestId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {

        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.transitData = resObj.Data;
          this.measurementDecisionForm.patchValue({
            IsArrived: true,
            ETA: resObj.Data.ArrivalDateTime,
            ETATime: new Date(resObj.Data.ArrivalDateTime),
            Requirements: resObj.Data.Requirements
          });
          this.measurementDecisionForm.controls.IsArrived.disable();
          this.measurementDecisionForm.controls.ETA.disable();
          this.measurementDecisionForm.controls.ETATime.disable();
          this.measurementDecisionForm.controls.Requirements.disable();
        }
      });
  }
  public getTransitRequest() {
    this.transitSrv.get(this.baseRequestId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {

        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.transitData = resObj.Data;

          if (this.transitData.IsPendingDocument) {
            this.measurementDecisionForm.patchValue({
              Decision: MeasurementDecision.PendingDocuments,
              DocuemntName: this.transitData.DocuemntName,
              MeasureExtraFee: this.transitData.MeasureExtraFee,
              MeasurementDescription: this.transitData.MeasurementDescription
            });
          }
          else {
            this.measurementDecisionForm.patchValue({
              Decision: MeasurementDecision.Approve,
              DocuemntName: this.transitData.DocuemntName,
              MeasureExtraFee: this.transitData.MeasureExtraFee,
              MeasurementDescription: this.transitData.MeasurementDescription

            });
          }
          this.measurementDecisionForm.disable();
          this.formMode = FormMode.Readonly;
        }
      });
  }


  changeDecision(value) {
    this.decisionValue = value;
    const documentName = this.measurementDecisionForm.get('DocuemntName');
    if (value == MeasurementDecision.PendingDocuments) {
      documentName.setValidators([Validators.required, CustomValidators.textSpaceValidator()]);
      documentName.updateValueAndValidity();
    }
    else {
      documentName.clearValidators();
      documentName.updateValueAndValidity();
    }
  }

  get f() {
    return this.measurementDecisionForm.controls;
  }


  onSubmit() {

    this.submitted = true;
    // stop here if form is invalid
    if (this.measurementDecisionForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.adminDecisionObject = this.measurementDecisionForm.value;
    this.adminDecisionObject.AdminEmail = this.user.UserName;
    this.adminDecisionObject.RequestId = this.baseRequestId;


    this.adminSrv.measurementDecisionTransit(this.adminDecisionObject)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            //this.alertService.success('Decision Submitted Successfully', false);
            this.measurementDecisionForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
            // this.router.navigate(['/Tasks']);
          } else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          } else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            // this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + data.ErrorMessages[0]), false);
            // const el = document.getElementsByClassName('alert-danger');
            // el[0].scrollIntoView({ behavior: 'smooth' });
            this.loading = false;
          }

        });
  }
}
